import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postContractHideColumnData = createApi('cdPlannerHiddenColumns', 'POST');

const PostContractHideColumns = createSlice({
  name: 'PostContractHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postContractHideColumnData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postContractHideColumnData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postContractHideColumnData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostContractHideColumns.reducer;